import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import { currencyFormat } from 'helpers/utils';
import { Link } from 'react-router-dom';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import { Order, ordersTableData } from 'data/e-commerce/orders';
import Badge from 'components/base/Badge';
import FeatherIcon from 'feather-icons-react';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import moment from 'moment';

export const ordersTableColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'walletAddress',
    header: 'Wallet Address',
    cell: ({ row: { original } }) => {
      const { walletAddress } = original;
      return (
        <Link to="#!" className="fw-semibold">
          {walletAddress}
        </Link>
      );
    },
    meta: {
      headerProps: { style: { width: '40%' }, className: 'pe-3' }
    }
  },
  {
    accessorKey: 'email',
    header: 'Email',
    meta: {
      headerProps: { style: { width: '30%' } },
      cellProps: { className: 'text-body fs-9' }
    }
  },
  {
    id: 'isActive',
    accessorKey: 'isActive',
    header: 'Status',
    cell: ({ row: { original } }) => {
      const { isActive } = original;
      return <span>{isActive ? 'Active' : 'Inactive'}</span>;
    },
    meta: {
      headerProps: { style: { width: '20%' }, className: 'pe-3' }
    }
  },
  {
    accessorKey: 'createdAt',
    header: 'Created At',
    cell: ({ row: { original } }) => {
      const { createdAt } = original;
      return <span>{moment(createdAt).format('LLL')}</span>;
    },
    meta: {
      headerProps: { className: 'text-end' },
      cellProps: {
        className:
          'text-body-tertiary fs-9 ps-4 text-end white-space-nowrap pt-2 pb-2'
      }
    }
  }
];

const UserWalletTable = ({ userWallets }: { userWallets: any[] }) => {
  const table = useAdvanceTable({
    data: userWallets,
    columns: ordersTableColumns,
    pageSize: 6,
    pagination: true,
    sortable: true
  });

  return (
    <AdvanceTableProvider {...table}>
      <div className="border-y border-translucent">
        <AdvanceTable
          tableProps={{ className: 'phoenix-table table-sm fs-9' }}
        />
        <AdvanceTableFooter pagination showViewAllBtn={false} />
      </div>
    </AdvanceTableProvider>
  );
};

export default UserWalletTable;
